import { render, staticRenderFns } from "./PanelAdminBot.vue?vue&type=template&id=24e4f6cc"
import script from "./PanelAdminBot.vue?vue&type=script&lang=js"
export * from "./PanelAdminBot.vue?vue&type=script&lang=js"
import style0 from "./PanelAdminBot.vue?vue&type=style&index=0&id=24e4f6cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports